import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import TopNav from "../components/home/TopNav";
import ProductCard from "../components/ProductCard";
import { fitmentData }
from "../data/fitmentData";





export default function CreateListingScreen() {


const { listingId } = useParams();
const isEditMode = !!listingId;

 const [form, setForm] = useState({
  title: "",
  partNumber: "",
  eid: "",
  badge: "",
  manufacturer: "",
  description: "",
  keywords: "",
  category: "", 
  condition: "used",
 weightValue: "",
weightUnit: "lbs",
  color: "",
  material: "",
  unitsAvailable: "",
  images: [],
  // 🔥 NEW
  year: "",
  useYearRange: false,
  yearStart: "",
  yearEnd: "",
model: "",
partType: "Factory OEM",
conditionGrade: "",
conditionNotes: "",
sku: "",
costPrice: "",
supplier: "",
binLocation: "",
lowStockThreshold: "",
altPartNumbers: "",
compatibilityNotes: "",
compatibleFitments: [],
isFeatured: false,
isPublished: true


});


const [variants, setVariants] = useState({
  new: { price: "", stock: "" },
  used: { price: "", stock: "" }
});

const [variantImages, setVariantImages] = useState({
  new: [],
  used: []
});
const selectedYear =
  form.useYearRange
    ? form.yearStart
    : (form.year || form.yearStart);

// Multi-fitment picker state
const [fitmentPicker, setFitmentPicker] = useState({ manufacturer: "", year: "", model: "" });
const fitmentPickerModels = fitmentData[fitmentPicker.manufacturer]?.[fitmentPicker.year] || [];



const models =
  fitmentData[
    form.manufacturer
  ]?.[
    selectedYear
  ] || [];



  
useEffect(() => {

  if (!listingId) return;

  fetch(`https://eleven11-i6v4.onrender.com/api/listings/${listingId}`)
    .then(res => res.json())
    .then(data => {

      setForm(prev => ({

  ...prev,

  ...data,

  // RESTORE INTERCHANGEABLE YEARS
  useYearRange:
    data.yearStart &&
    data.yearEnd &&
    data.yearStart !== data.yearEnd,

  // RESTORE YEAR VALUES
  year:
    data.yearStart || "",

  yearStart:
    data.yearStart || "",

  yearEnd:
    data.yearEnd || "",

keywords:
    (data.keywords || []).join(", "),

compatibleFitments: data.compatibleModels || data.compatibleFitments || [],

  images:
    (data.images || []).map(img => ({
      preview: `${img}`,
      existing: true,
      path: img
    }))

}));


 // ✅ LOAD VARIANTS PROPERLY
      if (data.variants) {
        const newState = {
          new: { price: "", stock: "" },
          used: { price: "", stock: "" }
        };

        data.variants.forEach(v => {
          if (v.condition === "new") {
            newState.new = {
              price: v.price,
              stock: v.stock
            };
          }

          if (v.condition === "used") {
            newState.used = {
              price: v.price,
              stock: v.stock
            };
          }
        });

   setVariants(newState);

        setVariantImages({
          new: (data.variants?.find(v => v.condition === "new")?.images || []).map(img => ({ preview: img, existing: true, path: img })),
          used: (data.variants?.find(v => v.condition === "used")?.images || []).map(img => ({ preview: img, existing: true, path: img }))
        });
      }

    })


    .catch(err => console.error(err));

}, [listingId]);

const handleImageUpload = (files) => {

  const newImages = Array.from(files).map((file) => ({
    file,
    preview: URL.createObjectURL(file)
  }));

  setForm(prev => ({
  ...prev,
  images: [...prev.images, ...newImages]
}));

};


const removeImage = (index) => {

  const updated = [...form.images];

  // ONLY revoke blob URLs
  if (updated[index].file) {
    URL.revokeObjectURL(updated[index].preview);
  }

  updated.splice(index, 1);

  setForm(prev => ({
    ...prev,
    images: updated
  }));

};


const handleChange = (e) => {
  const { name, value } = e.target;

  setForm(prev => {
    const updated = { ...prev, [name]: value };

    // Auto-generate EID
    if (name === "partNumber") {
      updated.eid = value ? `E11-${value}` : "";
    }

    // 🔥 Reset model when key fitment fields change
   const currentModel = prev.model;

if (
  (name === "year" || name === "manufacturer" || name === "yearStart") &&
  currentModel
) {
  const validModels =
fitmentData[
      name === "manufacturer" ? value : prev.manufacturer
    ]?.[
      name === "year" || name === "yearStart"
        ? value
        : (prev.useYearRange ? prev.yearStart : prev.year)
    ] || [];

  // only wipe if model no longer exists
  if (!validModels.includes(currentModel)) {
    updated.model = "";
  }
}
    return updated;
  });
};


  const handleSubmit = async () => {



  try {

   const formData = new FormData();


   const yearStart = form.useYearRange ? form.yearStart : form.year;
const yearEnd = form.useYearRange ? form.yearEnd : form.year;



// THEN append fields
const allowedFields = [
  "title", "partNumber", "eid", "badge", "partType", "description", "category",
  "condition", "weightValue", "weightUnit", "color", "material",
  "unitsAvailable", "conditionGrade", "conditionNotes", "sku",
  "costPrice", "supplier", "binLocation", "lowStockThreshold",
  "altPartNumbers", "compatibilityNotes"
];

allowedFields.forEach(key => {
  formData.append(key, form[key] || "");
});



// 🔥 overwrite with correct values
formData.append("yearStart", yearStart);
formData.append("yearEnd", yearEnd);
formData.append("model", form.model);
formData.append("manufacturer", form.manufacturer);

formData.append("isFeatured", form.isFeatured ? "true" : "false");
formData.append("isPublished", form.isPublished ? "true" : "false");

formData.append(
  "compatibleModels",
  JSON.stringify(form.compatibleFitments || [])
);

variantImages.new.forEach(img => { if (img.file) formData.append("newImages", img.file); });
variantImages.used.forEach(img => { if (img.file) formData.append("usedImages", img.file); });
formData.append("existingNewImages", JSON.stringify(variantImages.new.filter(i => i.existing).map(i => i.path)));
formData.append("existingUsedImages", JSON.stringify(variantImages.used.filter(i => i.existing).map(i => i.path)));


   const url = isEditMode
  ? `https://eleven11-i6v4.onrender.com/api/listings/${listingId}`
  : "https://eleven11-i6v4.onrender.com/api/listings";

const method = isEditMode ? "PUT" : "POST";

const formattedVariants = [];

if (variants.new.price) {
  formattedVariants.push({
    condition: "new",
    label: "Brand New",
    price: Number(variants.new.price),
    stock: Number(variants.new.stock || 0)
  });
}

if (variants.used.price) {
  formattedVariants.push({
    condition: "used",
    label: "Used (Like New)",
    price: Number(variants.used.price),
    stock: Number(variants.used.stock || 0)
  });
}

const keywordArray = form.keywords
  ? form.keywords
      .split(",")
      .map(k => k.trim())
      .filter(Boolean)
  : [];

formData.append(
  "keywords",
  JSON.stringify(keywordArray)
);

formData.append("variants", JSON.stringify(formattedVariants));



const token = localStorage.getItem("token");
const res = await fetch(url, {
  method,
  headers: token ? { Authorization: `Bearer ${token}` } : {},
  body: formData
});


const data = await res.json();



if (!res.ok) {
  throw new Error(data.error || "Request failed");
}


alert(
  isEditMode
    ? "Listing Updated Successfully"
    : "Listing Created Successfully"
);



  } catch (error) {



  }

};

 const styles = {

  page: {
    background: "#F6F7FB",
    minHeight: "100vh",
    fontFamily: "Inter, sans-serif"
  },

  layout: {
    display: "grid",
    gridTemplateColumns: "320px 1fr",
    gap: "30px",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "40px 20px"
  },

  leftCard: {
    background: "#FFFFFF",
    borderRadius: "16px",
    padding: "20px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
  },

  productImage: {
    width: "100%",
    borderRadius: "12px",
    marginBottom: "15px"
  },

  offerContainer: {
    background: "#FFFFFF",
    borderRadius: "16px",
    padding: "30px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)"
  },

  section: {
  marginBottom: "35px"
},


imagePreviewGrid: {
  display: "flex",
  gap: "10px",
  marginTop: "12px",
  flexWrap: "wrap"
},

previewImage: {
  width: "80px",
  height: "80px",
  objectFit: "cover",
  borderRadius: "10px",
  border: "1px solid #E5E5EA"
},


  label: {
  fontSize: "13px",
  marginBottom: "6px",
  marginTop: "14px",
  display: "block",
  color: "#6E6E73"
},


weightRow: {
  display: "flex",
  gap: "10px",
  alignItems: "center"
},

weightInput: {
  flex: 1,
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #E5E5EA",
  fontSize: "14px"
},

weightUnit: {
  width: "110px",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #E5E5EA",
  fontSize: "14px",
  background: "#fff"
},





variantBlock: {
  marginBottom: "20px",
  padding: "15px",
  border: "1px solid #E5E5EA",
  borderRadius: "12px",
  background: "#fafafa"
},

variantTitle: {
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: "10px"
},





  input: {
  width: "100%",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #E5E5EA",
  fontSize: "14px",
  marginBottom: "8px"
},

  textarea: {
  width: "100%",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #E5E5EA",
  fontSize: "14px",
  minHeight: "140px",
  marginBottom: "10px"
},

  submit: {
    marginTop: "20px",
    background: "#111",
    border: "none",
    padding: "14px",
    borderRadius: "12px",
    width: "100%",
    fontSize: "15px",
    color: "#fff",
    cursor: "pointer"
  }
};

  return (

    <div style={styles.page}>

  

      <div style={styles.layout}>

      {/* LEFT PRODUCT CARD */}

<div style={styles.leftCard}>

  <h3 style={{marginBottom:"20px"}}>Listing Preview</h3>


<ProductCard
  title={form.title || "OEM Jet Ski Wiring Harness"}
price={
  variants.used.price ||
  variants.new.price ||
  "0"
}
 image={
  form.images[0]?.preview ||
  (form.images[0] ? `${form.images[0]}` : undefined)
}
  delivery="Tomorrow"
  fastest="Today"
/>



</div>

        {/* RIGHT OFFER FORM */}

        <div style={styles.offerContainer}>

       <h2>{isEditMode ? "Edit Listing" : "Create Listing"}</h2>

         {/* IDENTIFICATION */}

<div style={styles.section}>

<label style={styles.label}>Manufacturer</label>

<select
  name="manufacturer"
  value={form.manufacturer}
  style={styles.input}
  onChange={handleChange}
>
  <option value="">Select Manufacturer</option>
  <option value="Yamaha">Yamaha</option>
  <option value="Sea-Doo">Sea-Doo</option>
  <option value="Kawasaki">Kawasaki</option>
   <option value="Kommander">Kommander / Fast Powersports</option>
    <option value="Crc Industries">Crc Industries</option>
     <option value="Liqui Moly">Liqui Moly</option>
      <option value="CorrosionX">CorrosionX</option>
       <option value="Salty Captain">Salty Captain</option>
        <option value="Salt Away">Salt Away</option>
         <option value="NGK">NGK Niterra</option>
</select>

<label style={styles.label}>Year</label>



<select
  name="year"
 value={
  form.useYearRange
    ? ""
    : (form.year || form.yearStart)
}
  style={styles.input}
  onChange={handleChange}
>
<option value="">Select Year</option>
  {[...Array(26)].map((_, i) => {
    const y = 2025 - i;
    return <option key={y} value={y}>{y}</option>;
  })}
</select>


<div style={{ marginTop: "10px" }}>
  <label>
    <input
      type="checkbox"
      checked={form.useYearRange}
      onChange={(e) =>
        setForm(prev => ({
          ...prev,
          useYearRange: e.target.checked,
         yearStart: prev.year || "",
         yearEnd: prev.year || "",
         model: ""
        }))
      }
    />
    {" "}Interchangeable Years
  </label>
</div>



{form.useYearRange && (
  <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
    <select
      name="yearStart"
      value={form.yearStart}
      style={styles.input}
      onChange={handleChange}
    >
    <option value="">From</option>
      {[...Array(26)].map((_, i) => {
        const y = 2025 - i;
        return <option key={y} value={y}>{y}</option>;
      })}
    </select>

    <select
      name="yearEnd"
      value={form.yearEnd}
      style={styles.input}
      onChange={handleChange}
    >
    <option value="">To</option>
      {[...Array(26)].map((_, i) => {
        const y = 2025 - i;
        return <option key={y} value={y}>{y}</option>;
      })}
    </select>
  </div>
)}

<label style={styles.label}>Compatible Models</label>

{/* Fitment Picker Row */}
<div style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
  <select
    value={fitmentPicker.manufacturer}
    style={{ ...styles.input, marginBottom: 0, flex: 1, minWidth: 120 }}
    onChange={e => setFitmentPicker(p => ({ ...p, manufacturer: e.target.value, year: "", model: "" }))}
  >
    <option value="">Manufacturer</option>
    <option value="Yamaha">Yamaha</option>
    <option value="Sea-Doo">Sea-Doo</option>
    <option value="Kawasaki">Kawasaki</option>
  </select>

  <select
    value={fitmentPicker.year}
    style={{ ...styles.input, marginBottom: 0, flex: 1, minWidth: 90 }}
    onChange={e => setFitmentPicker(p => ({ ...p, year: e.target.value, model: "" }))}
    disabled={!fitmentPicker.manufacturer}
  >
    <option value="">Year</option>
 {[...Array(26)].map((_, i) => {
      const y = 2025 - i;
      return <option key={y} value={String(y)}>{y}</option>;
    })}
  </select>

  <select
    value={fitmentPicker.model}
    style={{ ...styles.input, marginBottom: 0, flex: 2, minWidth: 140 }}
    onChange={e => setFitmentPicker(p => ({ ...p, model: e.target.value }))}
    disabled={!fitmentPicker.year || fitmentPickerModels.length === 0}
  >
    <option value="">Model</option>
    {fitmentPickerModels.map(m => <option key={m} value={m}>{m}</option>)}
  </select>

  <button
    type="button"
    onClick={() => {
      const { manufacturer, year, model } = fitmentPicker;
      if (!manufacturer || !year || !model) return;
      const entry = `${year} ${manufacturer} ${model}`;
      if (form.compatibleFitments.includes(entry)) return;
      setForm(p => ({ ...p, compatibleFitments: [...p.compatibleFitments, entry] }));
      setFitmentPicker(p => ({ ...p, model: "" }));
    }}
    style={{ padding: "10px 16px", borderRadius: 10, border: "none", background: "#111", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}
  >
    + Add
  </button>
</div>

{/* Tagged fitments */}
{form.compatibleFitments.length > 0 && (
  <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
    {form.compatibleFitments.map((entry, i) => (
      <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, background: "#f0f0ff", border: "1px solid #c7c7ff", borderRadius: 999, padding: "5px 12px", fontSize: 12, fontWeight: 600, color: "#3730a3" }}>
        {entry}
        <button
          type="button"
          onClick={() => setForm(p => ({ ...p, compatibleFitments: p.compatibleFitments.filter((_, idx) => idx !== i) }))}
          style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: 14, lineHeight: 1, padding: 0 }}
        >×</button>
      </div>
    ))}
  </div>
)}


<label style={styles.label}>Category</label>

<select
  name="category"
  value={form.category}
  style={styles.input}
  onChange={handleChange}
>
  <option value="">Select Category</option>

  <option value="Parts">Parts</option>
  <option value="Accessories">Accessories</option>
  <option value="Marine Detailing">Marine Detailing</option>
  <option value="Lubricants & Sprays">Lubricants & Sprays</option>
  <option value="Fluids & Maintenance">Fluids & Maintenance</option>
</select>


<label style={styles.label}>Listing Condition</label>

<select
  name="condition"
  value={form.condition}
  style={styles.input}
  onChange={handleChange}
>
  <option value="used">Used</option>
  <option value="new">Brand New</option>
</select>



<label style={styles.label}>Factory Part Number</label>

            <input
              name="partNumber"
              value={form.partNumber}
              style={styles.input}
              onChange={handleChange}
            />

            <label style={styles.label}>Title</label>

            <input
              name="title"
              value={form.title}
              style={styles.input}
              onChange={handleChange}
            />

            <label style={styles.label}>EID (Eleven Identification)</label>

            <input
              name="eid"
              value={form.eid}
              style={styles.input}
              onChange={handleChange}
            />

<label style={styles.label}>Social Proof Badge</label>
<input
  name="badge"
  value={form.badge}
  style={styles.input}
  onChange={handleChange}
  placeholder='e.g. "5K+ Ordered This Month" or "Top Seller"'
/>

<label style={styles.label}>Part Type</label>
<select name="partType" value={form.partType || "Factory OEM"} onChange={handleChange} style={styles.input}>
  <option value="Factory OEM">Factory OEM</option>
  <option value="Reman OEM">Reman OEM</option>
  <option value="OEM Takeoff">OEM Takeoff</option>
  <option value="Aftermarket">Aftermarket</option>
</select>

          </div>

          {/* DESCRIPTION */}

          <div style={styles.section}>

            <label style={styles.label}>Description</label>

            <textarea
              name="description"
              value={form.description}
              style={styles.textarea}
              onChange={handleChange}
            />

          </div>



<label style={styles.label}>
  Search Keywords
</label>

<input
  name="keywords"
  value={form.keywords}
  style={styles.input}
  onChange={handleChange}
  placeholder="fuel pump, yamaha oem, marine fuel system"
/>


{/* INVENTORY */}

<div style={styles.section}>

<label style={styles.label}>Units Available</label>

<input
  type="number"
  name="unitsAvailable"
  value={form.unitsAvailable}
  style={styles.input}
  onChange={handleChange}
/>

</div>



          {/* SPECS */}

          <div style={styles.section}>

          <label style={styles.label}>Weight</label>

<div style={styles.weightRow}>

<input
  name="weightValue"
  value={form.weightValue}
  style={styles.weightInput}
  onChange={handleChange}
  placeholder="0"
/>

<select
  name="weightUnit"
  value={form.weightUnit}
  style={styles.weightUnit}
  onChange={handleChange}
>
  <option value="lbs">lbs</option>
  <option value="oz">oz</option>
  <option value="g">grams</option>
  <option value="kg">kg</option>
</select>

</div>

            <label style={styles.label}>Color</label>

            <input
              name="color"
              value={form.color}
              style={styles.input}
              onChange={handleChange}
            />

            <label style={styles.label}>Material</label>

            <input
              name="material"
              value={form.material}
              style={styles.input}
              onChange={handleChange}
            />

          </div>

{/* CONDITION RATING */}
<div style={styles.section}>
  <h3 style={{ marginBottom: 12 }}>Condition Rating</h3>
  <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 10, marginBottom: 16 }}>
    {[
      { key: "excellent", label: "Excellent", sub: "Like new, no wear" },
      { key: "good", label: "Good", sub: "Minor signs of use" },
      { key: "fair", label: "Fair", sub: "Visible wear, fully functional" },
      { key: "poor", label: "Poor", sub: "Heavy wear, still works" },
    ].map(g => (
      <div key={g.key} onClick={() => setForm(p => ({ ...p, conditionGrade: g.key }))} style={{ padding: "14px 12px", borderRadius: 12, border: `2px solid ${form.conditionGrade === g.key ? "#f43f5e" : "#E5E5EA"}`, background: form.conditionGrade === g.key ? "#fff1f2" : "#fafafa", cursor: "pointer" }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: form.conditionGrade === g.key ? "#f43f5e" : "#111" }}>{g.label}</div>
        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>{g.sub}</div>
      </div>
    ))}
  </div>
  <label style={styles.label}>Condition Notes <span style={{ fontWeight: 400, color: "#9ca3af" }}>(optional)</span></label>
  <textarea name="conditionNotes" value={form.conditionNotes || ""} onChange={handleChange} style={styles.textarea} placeholder="e.g. Small scratch on housing, otherwise perfect. All connectors intact." />
</div>

{/* INTERNAL / OPERATIONS */}
<div style={styles.section}>
  <h3 style={{ marginBottom: 12 }}>Internal & Operations</h3>

  <label style={styles.label}>SKU / Internal Reference</label>
  <input name="sku" value={form.sku || ""} onChange={handleChange} style={styles.input} placeholder="e.g. YAM-ECU-001" />

  <label style={styles.label}>Cost Price (private — not shown to customers)</label>
  <input type="number" name="costPrice" value={form.costPrice || ""} onChange={handleChange} style={styles.input} placeholder="0.00" />

  <label style={styles.label}>Supplier / Source</label>
  <input name="supplier" value={form.supplier || ""} onChange={handleChange} style={styles.input} placeholder="e.g. Dealer Auction, Wholesale, Direct Pull" />

  <label style={styles.label}>Bin / Shelf Location</label>
  <input name="binLocation" value={form.binLocation || ""} onChange={handleChange} style={styles.input} placeholder="e.g. A3-B2, Shelf 4" />

  <label style={styles.label}>Low Stock Alert Threshold</label>
  <input type="number" name="lowStockThreshold" value={form.lowStockThreshold || ""} onChange={handleChange} style={styles.input} placeholder="3" />

  <label style={styles.label}>Alternate Part Numbers <span style={{ fontWeight: 400, color: "#9ca3af" }}>(optional)</span></label>
  <input name="altPartNumbers" value={form.altPartNumbers || ""} onChange={handleChange} style={styles.input} placeholder="e.g. 6BH-13750-00-00, 6BH-13750-09-00" />

  <label style={styles.label}>Compatibility Notes <span style={{ fontWeight: 400, color: "#9ca3af" }}>(optional)</span></label>
  <textarea name="compatibilityNotes" value={form.compatibilityNotes || ""} onChange={handleChange} style={{ ...styles.textarea, minHeight: 80 }} placeholder="e.g. Fits 2019 FX SVHO but requires bracket E11-XXXXX" />

  <div style={{ display: "flex", gap: 24, marginTop: 16 }}>
    <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, cursor: "pointer" }}>
      <input type="checkbox" checked={form.isFeatured} onChange={e => setForm(p => ({ ...p, isFeatured: e.target.checked }))} style={{ width: 16, height: 16, accentColor: "#6366f1" }} />
      <span>Featured listing</span>
    </label>
    <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, cursor: "pointer" }}>
      <input type="checkbox" checked={form.isPublished} onChange={e => setForm(p => ({ ...p, isPublished: e.target.checked }))} style={{ width: 16, height: 16, accentColor: "#10b981" }} />
      <span>Published (visible to customers)</span>
    </label>
  </div>
</div>


          {/* PRICE */}

          <div style={styles.section}>

           {/* CONDITION & PRICING */}
<div style={styles.section}>

  <h3 style={{ marginBottom: "10px" }}>Condition & Pricing</h3>

  {/* BRAND NEW */}
  <div style={styles.variantBlock}>
    <div style={styles.variantTitle}>Brand New (OEM)</div>

    <input
      type="number"
      placeholder="Price"
      value={variants.new.price}
      style={styles.input}
      onChange={(e) =>
        setVariants({
          ...variants,
          new: { ...variants.new, price: e.target.value }
        })
      }
    />

  <input
      type="number"
      placeholder="Stock"
      value={variants.new.stock}
      style={styles.input}
      onChange={(e) =>
        setVariants({
          ...variants,
          new: { ...variants.new, stock: e.target.value }
        })
      }
    />
    <label style={styles.label}>Photos — Brand New</label>
    <input type="file" accept="image/*" multiple onChange={e => {
      const imgs = Array.from(e.target.files).map(file => ({ file, preview: URL.createObjectURL(file) }));
      setVariantImages(p => ({ ...p, new: [...p.new, ...imgs] }));
    }} />
    <div style={styles.imagePreviewGrid}>
      {variantImages.new.map((img, i) => (
        <div key={i} style={{ position: "relative" }}>
          <img src={img.preview} style={styles.previewImage} />
          <button type="button" onClick={() => {
            if (variantImages.new[i].file) URL.revokeObjectURL(variantImages.new[i].preview);
            setVariantImages(p => ({ ...p, new: p.new.filter((_, idx) => idx !== i) }));
          }} style={{ position:"absolute", top:"-6px", right:"-6px", background:"#111", color:"#fff", border:"none", borderRadius:"50%", width:"22px", height:"22px", cursor:"pointer" }}>×</button>
        </div>
      ))}
    </div>
  </div>

  {/* USED */}


  <div style={styles.variantBlock}>
    <div style={styles.variantTitle}>Used (Like New)</div>

    <input
      type="number"
      placeholder="Price"
      value={variants.used.price}
      style={styles.input}
      onChange={(e) =>
        setVariants({
          ...variants,
          used: { ...variants.used, price: e.target.value }
        })
      }
    />

  <input
      type="number"
      placeholder="Stock"
      value={variants.used.stock}
      style={styles.input}
      onChange={(e) =>
        setVariants({
          ...variants,
          used: { ...variants.used, stock: e.target.value }
        })
      }
    />
    <label style={styles.label}>Photos — Used</label>
    <input type="file" accept="image/*" multiple onChange={e => {
      const imgs = Array.from(e.target.files).map(file => ({ file, preview: URL.createObjectURL(file) }));
      setVariantImages(p => ({ ...p, used: [...p.used, ...imgs] }));
    }} />
    <div style={styles.imagePreviewGrid}>
      {variantImages.used.map((img, i) => (
        <div key={i} style={{ position: "relative" }}>
          <img src={img.preview} style={styles.previewImage} />
          <button type="button" onClick={() => {
            if (variantImages.used[i].file) URL.revokeObjectURL(variantImages.used[i].preview);
            setVariantImages(p => ({ ...p, used: p.used.filter((_, idx) => idx !== i) }));
          }} style={{ position:"absolute", top:"-6px", right:"-6px", background:"#111", color:"#fff", border:"none", borderRadius:"50%", width:"22px", height:"22px", cursor:"pointer" }}>×</button>
        </div>
      ))}
    </div>
  </div>

</div>


          </div>
<button
  type="button"
  style={styles.submit}
  onClick={handleSubmit}
>
  {isEditMode ? "Save Changes" : "Create Listing"}
</button>

        </div>

      </div>

    </div>
  );
}